import { IApplicationContext } from 'shared/types/applicationContext';
import { TFetchFormParams, TFormResponse } from 'shared/types/form';

export async function fetchModalForm(
  { httpApi }: IApplicationContext,
  params: TFetchFormParams,
): Promise<TFormResponse> {
  const { response } = await httpApi.fetch(
    {
      apiType: 'external',
      microserviceName: 'info-api',
      assertStatusCodes: [200],
      method: 'POST',
      pathApi: '/api/pik/v1/save-form-request',
      parameters: params,
    },
    {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
      },
    },
  );

  return response;
}
